import { render, staticRenderFns } from "./group-list.component.vue?vue&type=template&id=4f49aea7&"
import script from "./group-list.component.vue?vue&type=script&lang=js&"
export * from "./group-list.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports